export const tipe_item = [
    {key:'pendidikan', value:'Pendidikan'},
    {key:'sembako', value:'Sembako'},
    {key:'kesehatan', value:'Kesehatan'},
    {key:'tunai', value:'Uang Tunai'},
]



export const group_pendidikan = [
    {key:'sd', value:'SD'},
    {key:'smp', value:'SMP'},
    {key:'sma', value:'SMA'},
]

export const periode_penerimaan = [
    {key:'sekali', value:'Sekali'},
    {key:'perbulan', value:'Perbulan'}
]

export const jenis_pengisian = [
    {key:'fixed', value:'Fixed'},
    {key:'maksimal', value:'Maksimal'}
]

export const penerima_item = [
    {key:'perkk', value:'Per Keluarga'},
    {key:'perorang', value:'Per Orang'}
]

export const model_transaksi = [
    {key:'tunai', value:'Tunai'},
    {key:'nontunai', value:'Non Tunai'}
]


// WEBPACK FOOTER //
// ./src/constants/itemAnggaran.js